import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingController, ModalController, Platform } from '@ionic/angular';
import { HygieneCheckPageComponent } from '../../pages/hygiene-check-page/hygiene-check-page.component';
import { ChecksService } from '../../../services/checks.service';
import { DepartmentInterface, WardInterface } from '../../../models/wards-interface';
//import { TranslateService } from '../../../services/translate.service';
import { CheckStorageService } from '../../../services/check-storage.service';
import { DataFormPostCheck } from '../../../models/check-interface';
import { TranslateService } from "@ngx-translate/core";
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription } from 'rxjs';
import { PHBHPFeaturePackageInsitutionManagementService } from 'src/app/institution/ph-bhp-feature-package-insitution-management.service';
import { AppConfig } from 'src/app/app.config';
import { QuestionnaireInterface } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/models/questionnaire-interface';
import { QuestionnairesService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/lib/services/questionnaires.service';

@Component({
  selector: 'lib-hygiene-check-form',
  templateUrl: './hygiene-check-form.component.html',
  styleUrls: ['./hygiene-check-form.component.scss']
})
export class HygieneCheckFormComponent implements OnInit {

  public wards!: WardInterface[];
  public departments!: DepartmentInterface[];
  public questionnaires!: QuestionnaireInterface[];
  public hygieneSelected: string = '';
  public hygieneCheckForm: FormGroup;
  public activityControl: any;
  public loader: any;
  private subscriptionInstitution: Subscription;
  public isInstitutionConfigured: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private platform: Platform,
    private modalCtrl: ModalController,
    private translateService: TranslateService,
    private checkStorageService: CheckStorageService,
    private questionnaireService: QuestionnairesService,
    private institutionService: PHBHPFeaturePackageInsitutionManagementService,
    private config: AppConfig,
    public layoutService: PHBHPLayoutPackageService,
  ) {
    this.hygieneCheckForm = this.formBuilder.group({
      ward: ['', Validators.required],
      wardId: [''],
      department: [{ value: '', disabled: true }, Validators.required],
      questionnaire: [''],
      questionnaireId: [''],
      institutionId: [''],
      otherParticipants: ['']
    });
  }

  ngOnInit(): void {
    if (this.layoutService.institutionID) {
      this.layoutService.showLoader = true;
      this.checkStorageService.getWardsAndDepartments(this.layoutService.institutionID).subscribe((resp: any) => {
        if(resp) {
          this.wards = resp['wardsDetails'];
          this.wards = this.wards.filter((ward: WardInterface) => ward.departmentID != 0 && ward.isActive);
          this.departments = resp['departments'];

          if (this.wards && this.wards.length > 0) {
            this.isInstitutionConfigured = true;
          } else {
            this.isInstitutionConfigured = false;
          }

          this.onChangeSelectedItem(this.wards[0]);
        }else{
          this.isInstitutionConfigured = false;
        }
      }, (error) => { this.layoutService.showLoader = false; },
        () => { this.layoutService.showLoader = false; },
      );

      this.questionnaireService.getByInstitution(this.layoutService.institutionID).subscribe((questionnaires: any) => {
        this.setQuestionnaireOnList(questionnaires);
      });
    }

    this.subscriptionInstitution = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      if (!res) {
        this.router.navigateByUrl('hygiene-check-menu/hygiene-check');
        return;
      }

      this.layoutService.showLoader = true;
      this.institutionService.getInstitutionById(res).subscribe((institutionResponse) => {
        this.checkStorageService.getWardsAndDepartments(this.layoutService.institutionID).subscribe((resp: any) => {
          if(resp){
            this.wards = resp['wardsDetails'];
            this.wards = this.wards.filter((ward: WardInterface) => ward.departmentID != 0 && ward.isActive);
            this.departments = resp['departments'];
            if (this.wards && this.wards.length > 0) {
              this.isInstitutionConfigured = true;
            } else {
              this.isInstitutionConfigured = false;
            }
            this.onChangeSelectedItem(this.wards[0]);
          }else{
            this.isInstitutionConfigured = false;
          }
        }, (error) => { this.layoutService.showLoader = false; },
          () => { this.layoutService.showLoader = false; }
        );

        this.questionnaireService.getByInstitution(this.layoutService.institutionID).subscribe((questionnaires: any) => {
          this.setQuestionnaireOnList(questionnaires);
        });
      });
    });
  }

  setQuestionnaireOnList(questionnaires: QuestionnaireInterface[]): void {

    if (questionnaires.length === 0) {
      questionnaires = [{
        id: null,
        questionnaireName: this.layoutService.translateText('CHECK.DEFAULT_QUESTIONNAIRE'),
        isDefault: true
      }]
      return;
    }

    questionnaires.sort((a, b) => { return a.questionnaireName.localeCompare(b.questionnaireName); });
    this.questionnaires = questionnaires;
    const defaultQuestionnaireIndex = questionnaires.findIndex((questionnaire: QuestionnaireInterface) => questionnaire.isDefault === true);
    if (defaultQuestionnaireIndex === -1) {
      this.onChangeSelectedQuestionnaire(this.questionnaires[0]);
    } else {
      this.onChangeSelectedQuestionnaire(this.questionnaires[defaultQuestionnaireIndex]);
    }
  }

  submitForm() {
    const userData = localStorage.getItem('userData');
    const userDataJson = userData ? JSON.parse(userData) : [];

    const data: DataFormPostCheck = {
      institutionId: this.hygieneCheckForm.get('institutionId')?.value,
      wardId: this.hygieneCheckForm.get('wardId')?.value,
      furtherParticipant: this.hygieneCheckForm.get('otherParticipants')?.value,
      userId: userDataJson['userId'],
      questionnaireId: this.hygieneCheckForm.get('questionnaireId')?.value,
      id: '',
    }

    const wardDepartName: { wardName: string, departmentName: string } = {
      wardName: this.hygieneCheckForm.get('ward')?.value,
      departmentName: this.hygieneCheckForm.get('department')?.value,
    }

    if (!this.loader) {
      this.loader = true;
      this.layoutService.showLoader = true;
    }

    this.checkStorageService.postCheck(data, wardDepartName).subscribe((check: any) => {
      this.config.checkId = check.id;
      this.checkStorageService.putCheckUpdatedBy(this.config.checkId, this.config.userData.userId);
      this.layoutService.showLoader = false;
      this.checkStorageService.putCheckEditedBy(check.id, this.config.userData.userId).subscribe(() => {
        this.router.navigate(["/hygiene-check-menu/edit", check.id]);
      });
    }, (error) => { this.layoutService.showLoader = false; });
  }

  onChangeSelectedItem(item: WardInterface) {
    if(!item) return;
    if (this.checkStorageService.verifyNetworkStatus()) {
      this.hygieneCheckForm.get('ward')?.setValue(item.wardName);
      this.hygieneCheckForm.get('wardId')?.setValue(item.wardID);
      this.hygieneCheckForm.get('institutionId')?.setValue(item.institutionID);
      const departmentIndex = this.departments.findIndex(elem => elem.departmentID === item.departmentID);

      if (departmentIndex !== -1) {
        this.hygieneCheckForm.get('department')?.setValue(this.translateText(this.departments[departmentIndex].departmentName));
      }
    } else {
      this.hygieneCheckForm.get('ward')?.setValue(item.wardName);
      this.hygieneCheckForm.get('wardId')?.setValue(item.wardId);
      this.hygieneCheckForm.get('institutionId')?.setValue(item.institutionId);

      const departmentIndex = this.departments.findIndex(elem => elem.departmentID === item.deparmentId);

      if (departmentIndex !== -1) {
        this.hygieneCheckForm.get('department')?.setValue(this.translateText(this.departments[departmentIndex].departmentName));
      }
    }
  }

  onChangeSelectedQuestionnaire(item: QuestionnaireInterface) {
    this.hygieneCheckForm.get('questionnaire')?.setValue(this.translateText(item.questionnaireName));
    this.hygieneCheckForm.get('questionnaireId')?.setValue(item.id);
  }

  async openAppModal(id: string) {
    const modal = await this.modalCtrl.create({
      component: HygieneCheckPageComponent,
      componentProps: {
        id: id
      }
    })
    await modal.present();
  }

  translateText(text: string) {
    let result: string = text;
    this.translateService.get(text).subscribe((res: string) => {
      result = res;
    });
    return result;
  }

  onClickWardHandler(event: Event) {
    this.layoutService.showLoader = true;
    this.checkStorageService.getWardsAndDepartments(this.layoutService.institutionID).subscribe((resp: any) => {
      if(resp){
        this.wards = resp['wardsDetails'];
        this.wards = this.wards.filter((ward: WardInterface) => ward.departmentID != 0 && ward.isActive);
        this.departments = resp['departments'];
        if (!this.wards.find(ward => ward.wardID === this.hygieneCheckForm.get('wardId')?.value)) {
          this.onChangeSelectedItem(this.wards[0]);
        }
      }else{
        this.isInstitutionConfigured = false;
      }
    }, (error) => { }, () => { this.layoutService.showLoader = false; });
  }

  getDepartmentName() {
    var ward = this.wards?.find(ward => ward.wardID === this.hygieneCheckForm.get('wardId')?.value);
    var department = this.departments?.find(department => department.departmentID === ward?.departmentID);
    var departmentType = ward?.departmentTypeID === 1 ? '' : `(${this.layoutService.translateText(ward?.departmentTypeName)})`;
    return `${this.layoutService.translateText(department?.departmentName)} ${departmentType}`;
  }

  isQuestionnaireDisabled() {
    return this.questionnaires ? this.questionnaires.length <= 1 : false;
  }
}
